"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
function evalAll(createApi, oldModules, newModules) {
    for (const oldModule of oldModules) {
        const [newModule] = newModules.filter(m => m.name === oldModule.name);
        if (newModule) {
            newModules.splice(newModules.indexOf(newModule), 1);
        }
    }
    return utils_1.createModules(createApi, [...oldModules, ...newModules]);
}
/**
 * This strategy is dependent on the async parameter. If false it will start rendering when
 * everything has been received, otherwise it will start rendering when the metadata has been
 * received. In any case it will evaluate modules as fast as possible.
 */
function createProgressiveStrategy(async) {
    return (options, cb) => {
        const { fetchModules, fetchDependency, dependencies, getDependencies, cache, createApi, modules = [] } = options;
        const getDep = utils_1.getDependencyResolver(dependencies, getDependencies);
        const loader = utils_1.loadModulesMetadata(fetchModules, cache);
        const allModules = utils_1.createModules(createApi, [...modules]);
        if (async && allModules.length > 0) {
            cb(undefined, allModules);
        }
        const followUp = loader.then(metadata => metadata.map(m => utils_1.loadModule(m, getDep, fetchDependency).then(mod => {
            const available = modules.filter(m => m.name === mod.name).length === 0;
            metadata.pop();
            if (available) {
                allModules.push(utils_1.createModule(createApi, mod));
                if (async) {
                    cb(undefined, allModules);
                }
            }
            if (!async && metadata.length === 0) {
                cb(undefined, allModules);
            }
        })));
        return async ? loader.then() : followUp.then();
    };
}
exports.createProgressiveStrategy = createProgressiveStrategy;
/**
 * This strategy starts rendering when the modules metadata has been received.
 * Evaluates the modules once available without waiting for all modules to be
 * available.
 */
function blazingStrategy(options, cb) {
    const strategy = createProgressiveStrategy(true);
    return strategy(options, cb);
}
exports.blazingStrategy = blazingStrategy;
/**
 * The async strategy picked when no strategy is declared and async is set to
 * true. Directly renders, but waits for all modules to be available before
 * evaluating them.
 */
function asyncStrategy(options, cb) {
    standardStrategy(options, cb);
    return Promise.resolve();
}
exports.asyncStrategy = asyncStrategy;
/**
 * The standard strategy that is used if no strategy is declared and async is
 * false. Loads and evaluates all modules before rendering.
 */
function standardStrategy(options, cb) {
    const { fetchModules, fetchDependency, dependencies, getDependencies, cache, createApi, modules = [] } = options;
    return utils_1.loadModules(fetchModules, fetchDependency, dependencies, getDependencies, cache).then(newModules => cb(undefined, evalAll(createApi, modules, newModules)), error => cb(error, []));
}
exports.standardStrategy = standardStrategy;
